import { POST_API_PATH, GET_API_PATH } from "../../../constants"
import apiSetting from "../apiSetting"

const getOrderRule = async () => {
    try {
        const response = await apiSetting({ method: 'GET', url: GET_API_PATH.GET_URL_ORDER_RULES, data: null })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const updateOrderRule = async (data) => {
    try {
        const response = await apiSetting({ method: 'POST', url: POST_API_PATH.POST_URL_UPDATE_ORDER_RULE, data: data })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

export { getOrderRule, updateOrderRule } 